$(document).ready(function () {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
      // zresetuj modaly
      resetModal();
    }
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav-switcher').hasClass('is-open')) {
      $('.nav-switcher, .nav').removeClass('is-open');
      $('body').removeClass('is-unscrollable');
    } else {
      $('.nav-switcher, .nav').addClass('is-open');
      $('body').addClass('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav-switcher, .nav').removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  }

  function resetModal() {
    $('.modal').removeClass('is-open');
    $('.filtering__window').removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  }
  // spouštěč
  $('.nav-switcher').on('click', function () {
    switchMenu();
  });
  // resetuj menu po kliknutí na odkaz
  $('.nav a').on('click', function () {
    resetMenu();
  });

  // události při načtení stránky
  $(window).on('load', function () {
    // AOS fix pro první načítání
    // AOS.refresh();
  });

  // události při scroolování
  $(window).on('scroll', function () {
    //...
  });

  // modal okna
  if ($('.modal').length) {
    modal();
  }

  // filter
  if ($('.filtering').length) {
    filter();
  }

  // youtube video v modálním okně
  if ($('.js-video-start').length) {
    //new ModalVideo('.js-video-start', { channel: 'youtube' });
    $('.js-video-start').modalVideo({
      youtube: {
        controls: 1,
        autoplay: 1,
      },
    });
  }

  if ($('.slider').length) {
    $('.slider__wrap').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.slider__prev'),
      nextArrow: $('.slider__next'),
      dots: true,
      infinite: false,
      adaptiveHeight: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });
  }

  if ($('.date-slider').length) {
    $('.date-slider').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1.35,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.date-slider__prev'),
      nextArrow: $('.date-slider__next'),
      dots: false,
      infinite: false,
      adaptiveHeight: false,
      fade: false,
      autoplay: false,
      autoplaySpeed: 5000,
      touchtouchThreshold: 9999,
      mobileFirst: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            variableWidth: false,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            variableWidth: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            variableWidth: true,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            variableWidth: true,
          },
        },
      ],
    });
  }

  // filtrování taby / paginace
  if ($('.tabs').length) {
    $('.tabs').each(function (key) {
      var tabIdName = 'tabs' + key;
      this.id = tabIdName;

      jQuery('#' + tabIdName + ' .tabs__content').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $('#' + tabIdName + ' .tabs__btn-prev'),
        nextArrow: $('#' + tabIdName + ' .tabs__btn-next'),
        dots: false,
        infinite: false,
        adaptiveHeight: true,
        fade: true,
        autoplay: false,
        draggable: false,
        touchMove: false,
      });
      jQuery('#' + tabIdName + ' .tabs__nav').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $('#' + tabIdName + ' .tabs__btn-prev'),
        nextArrow: $('#' + tabIdName + ' .tabs__btn-next'),
        dots: false,
        fade: false,
        infinite: false,
        autoplay: false,
        variableWidth: true,
        asNavFor: $('#' + tabIdName + ' .tabs__content'),
        touchtouchThreshold: 9999,
        focusOnSelect: true,
      });
    });
  }

  if ($('.list--dropdown').length) {
    $('.list li').on('click', function () {
      if ($(this).hasClass('is-open')) {
        $(this).next('.list__answer').slideUp();
        //$(this).next('.list__answer').addClass('is-hidden');
        $(this).removeClass('is-open');
        $(this).closest('.section-category__wrap').removeClass('is-active');
      } else {
        $('.list__answer').slideUp();
        $('.list li').removeClass('is-open');
        $(this).addClass('is-open');
        $(this).next('.list__answer').slideDown();
        $(this).next('.list__answer').removeClass('is-hidden');
        $(this).closest('.section-category__wrap').addClass('is-active');
      }
    });
  }

  if ($('.js-show-table-more').length) {
    $('.js-show-table-more').click(function () {
      $(this).hide();
      $('.js-hidden-table-more')
        .removeClass('is-hidden')
        .addClass('is-animation-show-down');
    });
  }

  if ($('.js-show-table-more-2').length) {
    $('.js-show-table-more-2').click(function () {
      $(this).hide();
      $('.js-hidden-table-more-2')
        .removeClass('is-hidden')
        .addClass('is-animation-show-down');
    });
  }

  // video
  if ($('.media--video').length) {
    $('.media--video').on('click', function () {
      const video = $(this).find('video').get(0);
      if (!video) return;

      if (video.paused) {
        video.play();
        $(this).find('.media__play, .media__overlay').fadeOut();
        $(this).find('.media__overlay').removeClass('is-not-visible');
      } else {
        video.pause();
        $(this).find('.media__play, .media__overlay').fadeIn();
      }
    });
  }

  // faq
  if (document.querySelector('.faq')) {
    faqQuestion = document.getElementsByClassName('faq__question');
    for (i = 0; i < faqQuestion.length; i++) {
      faqQuestion[i].addEventListener('click', function () {
        if (this.closest('.faq__item').classList.contains('is-open')) {
          this.closest('.faq__item').classList.remove('is-open');
        } else {
          this.closest('.faq__item').classList.add('is-open');
        }
      });
    }
  }

  // dropdown
  if (document.querySelector('.dropdown')) {
    dropdownSwitch = document.getElementsByClassName('dropdown__switch');
    for (i = 0; i < dropdownSwitch.length; i++) {
      dropdownSwitch[i].addEventListener('click', function () {
        if (this.closest('.dropdown').classList.contains('is-open')) {
          this.closest('.dropdown').classList.remove('is-open');
        } else {
          this.closest('.dropdown').classList.add('is-open');
        }
      });
    }
  }

  // scroller (source: https://codepen.io/kevinpowell/pen/BavVLra)
  if (document.querySelector('.scroller')) {
    scroller();
  }

  // textarea počítadlo
  if (document.querySelector('.textarea__text')) {
    textArea = document.getElementsByClassName('textarea__text');
    //current = document.getElementsByClassName('textarea__current');
    for (i = 0; i < textArea.length; i++) {
      textArea[i].addEventListener('keyup', function () {
        let characterCount = this.value.length;
        let current =
          this.nextElementSibling.querySelector('.textarea__current');
        current.textContent = characterCount;
      });
    }
  }

  // select (dropdown)
  if (document.querySelector('.select')) {
    select = document.getElementsByClassName('select');

    for (i = 0; i < select.length; i++) {
      select[i].addEventListener('click', function (event) {
        event.stopPropagation();
        if (this.classList.contains('is-open')) {
          this.classList.remove('is-open');
        } else {
          closeAllSelect();
          select.forEach(function (element) {
            if (element.classList.contains('is-open')) {
              element.classList.remove('is-open');
            }
          });
          this.classList.add('is-open');
        }
      });
    }

    // zamezení zavření po kliknutí na tělo selectu
    selectContent = document.getElementsByClassName('select__content');
    for (i = 0; i < selectContent.length; i++) {
      selectContent[i].addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    // zavření selectu po kliknutí kdekoliv jinde na stránce
    document.addEventListener('click', function () {
      select.forEach(function (element) {
        if (element.classList.contains('is-open')) {
          element.classList.remove('is-open');
        }
      });
    });
  }

  // simplebar scrollbar pro select__content
  if (document.querySelector('.select__content')) {
    const selectContent = document.getElementsByClassName('select__content');
    for (let i = 0; i < selectContent.length; i++) {
      new SimpleBar(selectContent[i], {
        autoHide: false,
      });
    }
  }

  // simplebar scrollbar pro modal__body
  if (document.querySelector('.modal__body')) {
    const modalBody = document.getElementsByClassName('modal__body');
    for (let i = 0; i < modalBody.length; i++) {
      new SimpleBar(modalBody[i], {
        autoHide: false,
      });
    }
  }

  // tipy scroll efekt
  if (document.querySelector('.tips')) {
    tips();
  }

  // galerie
  if ($('.gallery').length) {
    $('.gallery a').simpleLightbox({
      showCounter: false,
    });
  }

  if ($('.grid-gallery').length) {
    $('.grid-gallery a').simpleLightbox({
      showCounter: false,
    });
  }

  const lightbox = GLightbox({
    keyboardNavigation: false,
    touchNavigation: false,
    autoplayVideos: true,
    controls: false,
    loop: false,
    plyr: {
      config: {
        ratio: '16:9', // or '4:3'
        muted: false,
        hideControls: true,
      },
    },
  });

  //attachment preview
  // if ($('.attachment-preview').length) {
  //   $('.attachment-preview a').simpleLightbox({
  //     showCounter: false,
  //     nav: false,
  //     overlayOpacity: 0.3,
  //   });
  // }

  //attachment preview
  // if ($('.attachment-preview').length) {
  //   $('.attachment-preview a').simpleLightbox({
  //     showCounter: false,
  //     nav: false,
  //     overlayOpacity: 0.3,
  //   });
  // }

  if ($('.input-password__toggle').length) {
    $('.input-password__toggle').click(function (event) {
      event.preventDefault();
      $(this).parent().toggleClass('is-active');

      var input = $($(this).attr('toggle'));

      if (input.attr('type') == 'password') {
        input.attr('type', 'text');
      } else {
        input.attr('type', 'password');
      }
    });
  }

  if (document.querySelector('.registerPageStep1')) {
    register();
  }
});
